import { CustomPrescriptionItem } from '../../../CustomPrescriptionItem/CustomPrescriptionItem'
import { ProductDetails } from '../../ProductSearchContextSlice'

export const getProductDisplayName = ({
  product,
  brandRequired = false,
}: {
  product: ProductDetails
  brandRequired: boolean
}): string => {
  const genericName = product.vis.map((vi) => vi.viName).join('+')
  if (!product.brand) {
    return genericName
  }
  if (product.aip?.lemi) {
    return product.productName
  }
  if (brandRequired) {
    return `${genericName} (${product.brand.brandName})`
  }
  return genericName
}

export const getProductDisplayNameNew = ({
  brandRequired,
  genericName,
  tradeName,
  product,
  tradeProductName,
}: {
  brandRequired: boolean
  tradeName: string
  genericName: string
  product: ProductDetails | undefined
  tradeProductName: string
}): string => {
  if (product?.aip?.lemi) {
    return tradeName || product.productName
  }

  if (brandRequired) {
    return `${genericName} (${tradeProductName})`
  }

  return genericName || (product ? product.vis.map((vi) => vi.viName).join('+') : '')
}

export const getProductDisplayNameCustomItem = (item: CustomPrescriptionItem): string => {
  return `${item.compoundName} ${item.itemStrength} ${item.dosageForm}`
}
